import { ProposalForm } from '../shared/ProposalForm';

export const TextProposalForm = () => {
  return <ProposalForm getProposalActions={() => []} />;
};
